import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Route from 'cio/routes/base';
import { CampaignType } from 'cio/models/campaign';

export default class IndexRoute extends Route {
  @service store;
  @service analytics;

  queryParams = {
    search: {
      replace: true,
      refreshModel: true,
    },
    tagIds: {
      replace: true,
      refreshModel: true,
    },
    page: {
      refreshModel: true,
    },
    sort: {
      refreshModel: true,
    },
    asc: {
      refreshModel: true,
    },
    sendToUnsubscribed: {
      refreshModel: true,
    },
    subscriptionTopicId: {
      refreshModel: true,
    },
    objectTypeIds: {
      replace: true,
      refreshModel: true,
    },
  };

  model(params) {
    let { page, search, tagIds, sort, asc, state, sendToUnsubscribed, subscriptionTopicId, objectTypeIds } = params;

    // API triggered broadcasts are also technically campaigns, so we query
    // campaigns and pass in the right type here.
    return this.store.query('campaign', {
      type: CampaignType.APITriggered,
      page: page - 1,
      search,
      tagIds,
      sort,
      asc,
      state,
      sendToUnsubscribed,
      subscriptionTopicId,
      objectTypeIds,
    });
  }

  async setupController() {
    super.setupController(...arguments);

    let listController = this.controllerFor('broadcasts.list');
    listController.fetchCounts();
    await listController.callAnalyticsForList();
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.setDefaultQueryParams();
  }

  @action
  reloadModel() {
    return this.refresh();
  }

  @action
  didTransition() {
    let controller = this.controllerFor('broadcasts.list');
    controller.transitionedIntoChildRoute(this.routeName);

    return true;
  }
}
